<cc-date-dropdown-anchor
    #anchor
    [type]="'filter'"
    [label]="label"
    [placeholder]="placeholderText"
    [value]="activeDate"
    [format]="'calendar'"
    [allowNoSelection]="true"
    (toggleList)="toggleList()"
>
</cc-date-dropdown-anchor>

@if (showModal) {
    <ddv-active-date-form
        [ccModal]="modalOptions"
        (dismissed)="closeList()"
        [fuzzyDates]="fuzzyDates"
        [(mode)]="mode"
        [(activeDate)]="activeDate"
        [minDate]="minDate"
        [maxDate]="maxDate"
        (modeChange)="onModeChange()"
        (activeDateChange)="isDirty = true"
    >
    </ddv-active-date-form>
}
